"use client";
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const API = '/api';

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000; // 1 second

export default function AnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    let isMounted = true;
    let retryCount = 0;

    const trackPageView = async (retry = 0) => {
      if (!isMounted) return;

      try {
        const response = await fetch(`${API}/analytics`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            path: pathname,
            userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
            timestamp: new Date().toISOString()
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        if (retry < MAX_RETRIES) {
          // Retry with exponential backoff
          const delay = RETRY_DELAY * Math.pow(2, retry);
          console.warn(`Analytics tracking failed (attempt ${retry + 1}/${MAX_RETRIES}), retrying in ${delay}ms...`, error);
          setTimeout(() => trackPageView(retry + 1), delay);
        } else {
          console.warn('Analytics tracking failed after maximum retries:', error);
        }
      }
    };

    // Track page view after a short delay to ensure page is loaded
    const timeoutId = setTimeout(() => {
      trackPageView(0);
    }, 1000);

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [pathname]);

  return null; // This component doesn't render anything
}
